import { isRejectedWithValue } from '@reduxjs/toolkit';
import { quizLogout } from '../slices/fun_stuff/quizAuthSlice';
import { toast }      from 'react-toastify';

const logoutOn401 = (store) => (next) => (action) => {
  if (
    isRejectedWithValue(action) &&
    action.payload?.status === 401 &&
    action.payload?.data?.code === 'TOKEN_EXPIRED'
  ) {
    toast.error('Session expired. Please log in again.');
    store.dispatch(quizLogout());
    window.location.href = '/quizgame';
  }
  return next(action);
};

export default logoutOn401